import React, { Component } from 'react';
import Scheduler, { SchedulerData, ViewTypes } from 'react-big-scheduler'
import { withCookies } from 'react-cookie';
import withDragDropContext from './withDnDContext'
import TasksIssuesReadOnlyFormComponent from '../TasksIssues/ReadOnlyFormComponent';

import 'react-big-scheduler/lib/css/style.css'
import moment from 'moment';

//import { DnDTypes } from './DnDTypes'

// for displayWeekend: True setting:
// schedulerWidth: window.innerWidth * 8 / 10,
// weekCellWidth: window.innerWidth / 10,
// weekResourceTableWidth: window.innerWidth / 10,

const formatter = 'YYYY-MM-DD';

let schedulerData = new SchedulerData(Date.now(), ViewTypes.Month, false, false, {
    schedulerWidth: window.innerWidth * 6 / 8,
    weekCellWidth: window.innerWidth / 8,
    weekResourceTableWidth: window.innerWidth / 8,
    agendaMaxEventWidth: 1000,
    displayWeekend: true,
    views: [
        { viewName: 'Agenda View', viewType: ViewTypes.Month, showAgenda: true, isEventPerspective: false },
        { viewName: 'Resource View', viewType: ViewTypes.Month, showAgenda: false, isEventPerspective: false },
        { viewName: 'Task View', viewType: ViewTypes.Month, showAgenda: false, isEventPerspective: true },
    ]
});

class SchedulerComponent extends Component {
    constructor(props) {
        super(props);
        const convertData = convert(props.data, props.projectId, props.departmentId);
        schedulerData.localeMoment.locale('en');
        schedulerData.setResources(props.resources);
        schedulerData.setEvents(convertData);

        this.state = {
            viewModel: schedulerData,
            events: convertData,
            windowHeight: undefined,
            windowWidth: undefined,

            openReadOnly: false,
            taskId: ''
        }
    }

    handleResize = () => {
        var data = this.state.viewModel;
        data.config.schedulerWidth = window.innerWidth * 6 / 8;
        data.config.weekCellWidth = window.innerWidth / 8;
        data.config.weekResourceTableWidth = window.innerWidth / 8;

        this.setState({
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth,
            viewModel: data,
        });
    }

    componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.data !== this.props.data) {
            if (nextProps.data.length > 0) {
                const convertData = convert(nextProps.data, nextProps.projectId, nextProps.departmentId);
                const filterData = filterDate(convertData, schedulerData.startDate, schedulerData.endDate)

                schedulerData.setEvents(filterData);

                this.setState({
                    viewModel: schedulerData,
                    events: convertData
                })
            }
        }

        if (nextProps.projectId !== this.props.projectId) {
            const convertData = convert(nextProps.data, nextProps.projectId, nextProps.departmentId);
            const filterData = filterDate(convertData, schedulerData.startDate, schedulerData.endDate)

            schedulerData.setEvents(filterData);

            this.setState({
                viewModel: schedulerData,
                events: convertData
            })
        }

        if (nextProps.resources !== this.props.resources) {
            schedulerData.setResources(nextProps.resources);

            this.setState({
                viewModel: schedulerData,
            })
        }

        if (nextProps.cookies) {
            var data = this.state.viewModel;

            //for DarkTheme
            nextProps.cookies.get('checkedDarkTheme') === 'true' ? data.config.nonWorkingTimeHeadColor = '#FFFFFF' : data.config.nonWorkingTimeHeadColor = 'rgb(153, 153, 153)';
            nextProps.cookies.get('checkedDarkTheme') === 'true' ? data.config.nonWorkingTimeHeadBgColor = '#62727b' : data.config.nonWorkingTimeHeadBgColor = 'rgb(255, 240, 246)';
            nextProps.cookies.get('checkedDarkTheme') === 'true' ? data.config.nonWorkingTimeBodyBgColor = '#62727b' : data.config.nonWorkingTimeBodyBgColor = 'rgb(255, 240, 246)';

            this.setState({
                viewModel: data
            })
        }
    }

    prevClick = (schedulerData) => {
        schedulerData.prev();

        const convertData = filterDate(this.state.events, schedulerData.startDate, schedulerData.endDate);
        schedulerData.setEvents(convertData);

        this.setState({
            viewModel: schedulerData,
        })
    }

    nextClick = (schedulerData) => {
        schedulerData.next();

        const convertData = filterDate(this.state.events, schedulerData.startDate, schedulerData.endDate);
        schedulerData.setEvents(convertData);

        this.setState({
            viewModel: schedulerData
        })
    }

    onViewChange = (schedulerData, view) => {
        schedulerData.setViewType(view.viewType, view.showAgenda, view.isEventPerspective);
        schedulerData.config.creatable = !view.isEventPerspective;
        // resoving react-big-scheduler's bug
        schedulerData.prev();
        schedulerData.next();

        const convertData = filterDate(this.state.events, schedulerData.startDate, schedulerData.endDate);
        schedulerData.setEvents(convertData);

        this.setState({
            viewModel: schedulerData
        })
    }

    onSelectDate = (schedulerData, date) => {
        schedulerData.setDate(date);
        const convertData = filterDate(this.state.evsents, schedulerData.startDate, schedulerData.endDate);
        schedulerData.setEvents(convertData);

        this.setState({
            viewModel: schedulerData
        })
    }

    eventClicked = (schedulerData, event) => {
        this.setState({
            openReadOnly: true,
            taskId: event.id
        })
    };

    updateEventStart = (schedulerData, event, newStart) => {
        const message = `Do you want to adjust the start of the event? {eventId: ${event.id}, eventTitle: ${event.title}, newStart: ${newStart}}`;

        if (window.confirm(message)) {
            schedulerData.updateEventStart(event, newStart);
            this.setState({
                viewModel: schedulerData
            })

            const filterData = this.props.data.find(item => {
                return item.TaskId === event.id
            })

            const now = moment(newStart);
            const end = moment(filterData.EndDate);
            const duration = moment.duration(end.diff(now)).days() + 1;

            const inputData = {
                "TaskId": filterData.TaskId,
                "AssignedToId": filterData.AssignedToId,
                "TaskName": filterData.TaskName,
                "TaskNotes": filterData.TaskNotes,
                "ProjectId": filterData.ProjectId,
                "Status": filterData.Status,
                "OwnerId": filterData.OwnerId,
                "CreatedUserId": filterData.CreatedUserId,
                "TaskType": filterData.TaskType,

                "StartDate": moment(newStart).format(formatter),
                "EndDate": moment(filterData.EndDate).format(formatter),
                "Duration": duration,
                "UpdatedUserId": this.props.userId
            };

            this.props.handleMoveData(inputData);
        }
        else {
            this.setState({
                viewModel: schedulerData
            })
        }
    }

    updateEventEnd = (schedulerData, event, newEnd) => {
        const message = `Do you want to adjust the end of the event? {eventId: ${event.id}, eventTitle: ${event.title}, newEnd: ${newEnd}}`;
        if (window.confirm(message)) {
            schedulerData.updateEventEnd(event, newEnd);
            this.setState({
                viewModel: schedulerData
            })

            const filterData = this.props.data.find(item => {
                return item.TaskId === event.id
            })

            const inputData = {
                "TaskId": filterData.TaskId,
                "AssignedToId": filterData.AssignedToId,
                "TaskName": filterData.TaskName,
                "TaskNotes": filterData.TaskNotes,
                "ProjectId": filterData.ProjectId,
                "Status": filterData.Status,
                "OwnerId": filterData.OwnerId,
                "TaskType": filterData.TaskType,
                "StartDate": moment(filterData.StartDate).format(formatter),
                "EndDate": moment(newEnd).format(formatter),
                "Duration": filterData.Duration,
                "CreatedUserId": filterData.CreatedUserId,
                "UpdatedUserId": this.props.userId
            };

            this.props.handleMoveData(inputData);
        }
        else {
            this.setState({
                viewModel: schedulerData
            })
        }
    }

    moveEvent = (schedulerData, event, slotId, slotName, newStart, newEnd) => {
        const message = `Do you want to move the event? {eventId: ${event.id}, eventTitle: ${event.title}, newSlotId: ${slotId}, newSlotName: ${slotName}, newStart: ${newStart}, newEnd: ${newEnd}`;
        if (window.confirm(message)) {
            schedulerData.moveEvent(event, slotId, slotName, newStart, newEnd);
            this.setState({
                viewModel: schedulerData
            })

            const filterData = this.props.data.find(item => {
                return item.TaskId === event.id
            })

            const formatter = 'YYYY-MM-DD';
            const now = moment(newStart);
            const end = moment(newEnd);
            const duration = moment.duration(end.diff(now)).days() + 1;

            const inputData = {
                "TaskId": filterData.TaskId,
                "AssignedToId": filterData.AssignedToId === event.resourceId ? filterData.AssignedToId : event.resourceId,
                "TaskName": filterData.TaskName,
                "TaskNotes": filterData.TaskNotes,
                "ProjectId": filterData.ProjectId,
                "Status": filterData.Status,
                "OwnerId": filterData.OwnerId,
                "CreatedUserId": filterData.CreatedUserId,
                "TaskType": filterData.TaskType,
                "StartDate": moment(newStart).format(formatter),
                "EndDate": moment(newEnd).format(formatter),
                "Duration": duration,
                "UpdatedUserId": this.props.userId,
                "ActualFinishDate": filterData.ActualFinishDate
            };

            this.props.handleMoveData(inputData);
        }
        else {
            this.setState({
                viewModel: schedulerData
            })
        }
    }

    subtitleGetter = (schedulerData, event) => {
        return schedulerData.isEventPerspective ? (schedulerData.getResourceById(event.resourceId) ? schedulerData.getResourceById(event.resourceId).name : "") : event.groupName;
    }

    handleReadOnlyClose = () => {
        this.setState({
            openReadOnly: false
        })
    }

    render() {
        const { viewModel } = this.state;

        return (
            <div>
                <Scheduler
                    schedulerData={viewModel}
                    prevClick={this.prevClick}
                    nextClick={this.nextClick}
                    onSelectDate={this.onSelectDate}
                    onViewChange={this.onViewChange}
                    // updateEventStart={this.updateEventStart}
                    // updateEventEnd={this.updateEventEnd}
                    moveEvent={this.moveEvent}
                    subtitleGetter={this.subtitleGetter}
                    eventItemClick={this.eventClicked}

                // newEvent={this.newEvent}
                // viewEventText="Ops 1"
                // viewEvent2Text="Ops 2"
                // viewEventClick={this.ops1}
                // viewEvent2Click={this.ops2}
                />

                <TasksIssuesReadOnlyFormComponent
                    open={this.state.openReadOnly}
                    close={this.handleReadOnlyClose}
                    TaskId={this.state.taskId}
                />
            </div>
        );
    }
}

function filterDate(data, startDate, endDate) {
    const filterDateData = data && data.filter(function (item) {
        if (moment(item.start).isBetween(startDate, endDate) ||
            moment(item.end).isBetween(startDate, endDate)) {
            return true
        }
        if (moment(startDate).isBetween(moment(item.start), moment(item.end)) ||
            moment(endDate).isBetween(moment(item.start), moment(item.end))) {
            return true
        }
        return false
    })

    return filterDateData
}

function convert(data, projectId, departmentId) {
    var formatter1 = 'YYYY-MM-DD';
    var filterData;

    if (departmentId) {
        const authenData = data ? data : []

        if (projectId.length !== 0) {
            filterData = authenData && authenData.filter(function (item) {
                return item.ProjectId === projectId;
            });
        }
        else {
            filterData = authenData;
        }
    }

    let transformData = filterData ? filterData.map((data, key) => {
        return {
            id: data.TaskId,
            start: moment(data.StartDate).format(formatter1) + ' 00:00:00',
            end: moment(data.EndDate).format(formatter1) + ' 23:59:59',
            resourceId: data.AssignedToId,
            title: (data.TaskType === 'Issue' ? '❉ Issue ' : '') + (data.ProjectName !== 'null' ? ' [' + data.ProjectName + '] ' + data.TaskName : ' [Pre-Sale] ' + data.TaskName),
            bgColor: colorConvert(data.Status),
            groupId: data.TaskId,
            groupName: data.ProjectName !== null ? data.TaskName : ' [Pre-Sale] ' + data.TaskName,
        };
    }) : [];

    transformData = transformData.sort(function (a, b) {
        a = moment(a.start, 'YYYY-MM-DD HH:mm');
        b = moment(b.start, 'YYYY-MM-DD HH:mm');
        return a - b
    });

    return transformData;
}

//#E53935 red 1
//#FDD835 yellow 2
//#43A047 green 3
//#757575 grey 4
function colorConvert(option) {
    switch (option) {
        case 1:
            return '#E53935'
        case 2:
            return '#EAC824'
        case 3:
            return '#43A047'
        case 4:
            return '#757575'
        default:
            return '#212121'
    }
}

export default withDragDropContext(withCookies(SchedulerComponent));


// WEBPACK FOOTER //
// ./src/components/TasksDiagram/SchedulerComponent.js